/**
 * UI Constants
 * Centralized UI strings, labels, and configuration
 */

export const UI_TEXT = {
  // Modal tabs
  tabs: {
    aiAnalysis: 'AI Analysis',
    aiAnalysisShort: 'AI',
    definition: 'Definition',
    definitionShort: 'Info',
    examples: 'Examples',
    examplesShort: 'Ex.',
    similar: 'Similar Fallacies',
    similarShort: 'Similar',
  },
  
  // Section headers
  headers: {
    fallacyReference: 'Logical Fallacy Reference Guide',
    fallacyAnalysis: 'Fallacy Analysis',
    analysisReasoning: 'Analysis Reasoning',
    betterWayToSayIt: 'Better Way to Say It',
    issuesDetected: 'Issues Detected',
    overallConfidence: 'Overall Confidence',
  },
  
  // Labels
  labels: {
    originalArgument: 'Original Argument',
    improvedVersion: 'Improved Version',
    hasIssue: 'Has Issue',
    hasIssues: 'Has Issues',
    strongerLogic: 'Stronger Logic',
    howToRespond: 'How to Respond',
    alternativeConsiderations: 'Alternative Considerations',
    alsoKnownAs: 'Also Known As',
    confidence: 'Confidence',
    severity: 'Severity',
  },
  
  // Buttons
  buttons: {
    analyzeText: 'Analyze Text',
    analyzing: 'Analyzing...',
    clearResults: 'Clear Results',
    showExamples: 'Show Examples',
    hideExamples: 'Hide Examples',
    tryExamples: 'Try Examples',
    backToGuide: 'Back to Guide',
    loadExample: 'Load Example',
    flipCard: 'Click to Flip',
    flipBack: 'Flip Back',
    moreDetails: 'More Details',
  },
  
  // Placeholders
  placeholders: {
    searchFallacies: 'Search fallacies by name, description, or alternative names...',
    analyzeText: "Paste the argument, statement, or text you'd like to analyze here...",
  },
  
  // Messages
  messages: {
    noFallaciesFound: 'No fallacies found',
    noSignificantIssues: 'No Significant Issues Found',
    logicalIssuesFound: 'Logical Issues Found',
    logicalFallacyDetected: 'Logical Fallacy Detected',
    tryAdjustingFilters: 'Try adjusting your search terms or filters.',
    loadedExample: 'Loaded example',
    selectExample: 'Select an example to load it into the text area for analysis:',
  },
  
  // Filter options
  filters: {
    allCategories: 'All Categories',
    allSeverities: 'All Severities',
  },
  
  // Formatting
  format: {
    showingOf: 'Showing {count} of {total} fallacies',
    charactersRemaining: '{current}/{max} characters',
  },
} as const;

export const UI_CONFIG = {
  // Display limits
  limits: {
    fallacyExamplesPreview: 2,
    alternativeNamesPreview: 3,
    similarFallaciesCount: 3,
  },
  
  // Modal sizes
  modal: {
    minHeight: 400,
  },
} as const;

export const SEVERITY_OPTIONS = ['High', 'Medium', 'Low'] as const;
